import { BookOpen } from "lucide-react";

const TopicsCoveredComponent = () => {
  return (
    <section className="py-12 px-4 custom-bg-color-01">
      <div className="max-w-4xl mx-auto">
        <h3 className="text-3xl font-bold text-center mb-12 custom-color-03">
          Temas abordados
        </h3>

        <div className="grid md:grid-cols-2 gap-6 ">
          {[
            "Quero mudar, mas não consigo",
            "A essência do aconselhamento bíblico",
            "O processo de aconselhar na prática",
            "Mitos e realidades: aconselhamento bíblico e saúde mental",
            "O aconselhamento bíblico na igreja local",
            "Depressão – mudar é possível",
            "Você pode mudar – dinâmica e processo da mudança",
            "Pecados escravizadores e liberdade em Cristo",
            "Mudando e ajudando a mudar (comida/telas/pornografia)",
            "Percorrendo o caminho da mudança",
          ].map((topic, index) => (
            <div
              key={index}
              className="flex items-start gap-3 p-4 rounded-lg border custom-bg-color-02 custom-border-color-05"
            >
              <BookOpen className="w-5 h-5 mt-1 flex-shrink-0 custom-color-05" />
              <span className="custom-color-01">{topic}</span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
export default TopicsCoveredComponent;
